export interface EnabledFacet {
    component: 'facetGroup' | 'facet';
    facets?: EnabledFacet[];
    facet?: string;
    layout?: string;
    facetsLabel?: Array<{
        _uid: string;
        label: string;
        locale: string;
        component: string;
    }>;
}

export const transformEnabledFacets = (enabledFacets: EnabledFacet[]) => {
    return enabledFacets.map((facet: EnabledFacet) => {
        if (facet.component === 'facetGroup') {
            return {
                facetsLabel: facet.facetsLabel,
                facets: facet.facets,
                component: 'facetGroup',
            };
        }

        return {
            facetsLabel: facet.facetsLabel,
            facet: facet.facet,
            layout: facet.layout,
            component: 'facet',
        };
    });
};
